import type { App } from 'vue'
import { setupPrimeVue } from './primevue'
import i18n from './i18n'

export function registerPlugins(app: App): void {
  setupPrimeVue(app)
  app.use(i18n)
}
